import { createContext, useContext } from 'react';

interface AssetRouteContextType {
  basePath: string;
  listPath: string;
  isWorkspaceMode: boolean;
}

const AssetRouteContext = createContext<AssetRouteContextType | null>(null);

export const AssetRouteProvider = AssetRouteContext.Provider;

export const useAssetRouting = (assetId: string) => {
  const ctx = useContext(AssetRouteContext);
  return (
    ctx ?? {
      basePath: `/assets/${assetId}`,
      listPath: '/assets',
      isWorkspaceMode: false,
    }
  );
};
